import {
  container,
//cardTitle,
//whiteColor,
//grayColor,
  ts_main
} from "assets/jss/material-dashboard-pro-react.jsx";

const RegisterLight1Style = theme => ({
  container: {
    ...container,
    backgroundColor: "#FFFFFF",
    zIndex: "4",
    [theme.breakpoints.down("sm")]: {
      paddingTop: "0px",
      paddingBottom: "0px"
    }
  },
  //------
  //Labels
  //------
  labelHeader: {
    marginTop        : 10,
    marginBottom     : 10,
    fontSize         : "1.7rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "300",
    color            : "#FFDD00",
    textAlign        : "center",
  },
  label1: {
    fontSize         : "1rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "300",
    color            : "#35B6B4",
    textAlign        : "left",
  },
  label_emailInfo: {
    fontSize         : "0.75rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "300",
    color            : "#35B6B4",
    textAlign        : "left",
  },
  RegisterLight1_lbl_consent1: {
    marginTop        : 10,
    marginBottom     : 10,
    fontSize         : "0.9rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "300",
    color            : "#303030",
    textAlign        : "left",
    "vertical-align" : "middle",
  },
  //------
  //Images
  //------
  logo: {
    margin           : "1rem 0",
    "& img"          : {
      width   : "25%",
      display : "block",
      margin  : "auto"
    },
    "& span"          : {
      width        : "100px",
      height       : "1px",
      borderBottom : "3px solid " + ts_main[3],
      display      : "block",
      margin       : "1rem auto"
    }
  },
  img2: {
    margin   : "0 0 0 0",
    align    : "left",
    "vertical-align":"middle",
  },
  //----------
  //Textfields
  //----------
  firstName: {
    marginTop        : 10,
    marginBottom     : 10,
    input            : { color : "303030" },
  },
  lastName: {
    marginTop        : 10,
    marginBottom     : 10,
    input            : { color : "303030" }
  },
  email: {
    marginTop        : 10,
    marginBottom     : 10,
    input            : { color : "303030" },
    "& input": {
      "-webkit-box-shadow": "none",
    },
    "& input:-webkit-autofill": {
      "-webkit-box-shadow": "0 0 0 1000px white inset !important",
      "-webkit-text-fill-color": "black !important",
    },
    "& input:-webkit-autofill:hover": {
      "-webkit-box-shadow": "0 0 0 1000px white inset !important",
      "-webkit-text-fill-color": "black !important",
    },
    "& input:-webkit-autofill:focus": {
      "-webkit-box-shadow": "0 0 0 1000px white inset !important",
      "-webkit-text-fill-color": "black !important",
    },
    "& input::-ms-reveal": {
      display: "none",
    },
    "& input::-ms-clear": {
      display: "none",
    },
  },
  password1: {
    marginTop        : 10,
    marginBottom     : 10,
    input            : { color : "303030" },
    "& input": {
      "-webkit-box-shadow": "none",
    },
    "& input:-webkit-autofill": {
      "-webkit-box-shadow": "0 0 0 1000px white inset !important",
      "-webkit-text-fill-color": "black !important",
    },
    "& input:-webkit-autofill:hover": {
      "-webkit-box-shadow": "0 0 0 1000px white inset !important",
      "-webkit-text-fill-color": "black !important",
    },
    "& input:-webkit-autofill:focus": {
      "-webkit-box-shadow": "0 0 0 1000px white inset !important",
      "-webkit-text-fill-color": "black !important",
    },
    "& input::-ms-reveal": {
      display: "none",
    },
    "& input::-ms-clear": {
      display: "none",
    },
  },
  password2: {
    marginTop        : 10,
    marginBottom     : 10,
    input            : { color : "303030" },
    "& input": {
      "-webkit-box-shadow": "none",
    },
    "& input:-webkit-autofill": {
      "-webkit-box-shadow": "0 0 0 1000px white inset !important",
      "-webkit-text-fill-color": "black !important",
    },
    "& input:-webkit-autofill:hover": {
      "-webkit-box-shadow": "0 0 0 1000px white inset !important",
      "-webkit-text-fill-color": "black !important",
    },
    "& input:-webkit-autofill:focus": {
      "-webkit-box-shadow": "0 0 0 1000px white inset !important",
      "-webkit-text-fill-color": "black !important",
    },
    "& input::-ms-reveal": {
      display: "none",
    },
    "& input::-ms-clear": {
      display: "none",
    },
  },
  birthCity: {
    marginTop        : 10,
    marginBottom     : 10,
    input            : { color : "303030" }
  },
  birthDate: {
    marginTop        : 10,
    marginBottom     : 10,
    input            : { color : "303030" },
    "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
        display: "none"
    },
    "& input::-webkit-clear-button": {
        display: "none",
    },
    "& input::-webkit-calendar-picker-indicator": {
        display: "none",
        "-webkit-appearance": "none",
        "-moz-appearance": "none",
    },
  },
  //--------
  //DropDown
  //--------
  preferredLanguage: {
    marginTop        : 10,
    marginBottom     : 10,
  },
  birthCountryId: {
    marginTop        : 10,
    marginBottom     : 10,
  },
  genderId: {
    marginTop        : 10,
    marginBottom     : 10,
  },
  birthDateDay   : { marginTop:10, marginBottom:10, },
  birthDateMonth : { marginTop:10, marginBottom:10, },
  birthDateYear  : { marginTop:10, marginBottom:10, },
  //-------
  //Buttons
  //-------
  yellowButton: {
    fontSize         : "0.9rem",
    textTransform    : "none",
    marginTop        : 50,
    marginBottom     : 20,
    color            : "#303030",
    backgroundColor  : "#FFDD00",
    width            : "100%",
    'border-radius'  : "25px",
    "&:hover"        : { fontWeight:"600", color:"#303030", background: "#FFDD00 !important"},
    "&:focus"        : { fontWeight:"600", color:"#303030", background: "#FFDD00 !important"},
  },
  backButton: {
    fontSize         : "0.9rem",
    textTransform    : "none",
    marginTop        : 0,
    marginBottom     : 20,
    color            : "#0000ff",
    backgroundColor  : "rgba(255, 255, 255, 1.0)",
    width            : "100%",
    'border-radius'  : "25px",
    "&:hover"        : { fontWeight:"600", color:"#0000ff !important", background: "rgba(255, 255, 255, 1.0) !important"},
    "&:focus"        : { fontWeight:"600", color:"#0000ff !important", background: "rgba(255, 255, 255, 1.0) !important"},
  },
  popupOkButton: {
    textTransform   : "none",
    backgroundColor : "#FFDD00",
    'border-radius' : "10px"
  },
  //----------
  //PleaseWait
  //----------
  pleaseWait: {
    marginTop        : 50,
  //marginBottom     : 0,
    fontSize         : "1rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "300",
    color            : "#303030",
    textAlign        : "center",
    display          : "flex",
    alignItems       : "center",
    justifyContent   : "center",
  },
  //---------------
  //PleaseWaitPopup
  //---------------
  pleaseWaitPopup: {
    marginTop        : 0,
    marginBottom     : 0,
    fontSize         : "1rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "300",
    color            : "#303030",
    textAlign        : "center",
    overflow         : "hidden",
    display          : "flex",
    alignItems       : "center",
    justifyContent   : "center",
  },

  GridItemLocal_d:{
  //paddingLeft  : "0px !important",
    paddingRight : "0px !important",
    paddingTop   : "0px !important",
    paddingBottom: "0px !important",
    marginLeft   : "0px !important",
    marginRight  : "0px !important",
    marginTop    : "0px !important",
    marginBottom : "0px !important",
  },
  GridItemLocal_m:{
    paddingLeft  : "4px !important",
    paddingRight : "4px !important",
    paddingTop   : "0px !important",
    paddingBottom: "0px !important",
    marginLeft   : "0px !important",
    marginRight  : "0px !important",
    marginTop    : "0px !important",
    marginBottom : "0px !important",
  },
  GridItemLocal_y:{
    paddingLeft  : "0px !important",
  //paddingRight : "0px !important",
    paddingTop   : "0px !important",
    paddingBottom: "0px !important",
    marginLeft   : "0px !important",
    marginRight  : "0px !important",
    marginTop    : "0px !important",
    marginBottom : "0px !important",
  },
  //---------
  //HONEYMOON
  //---------
  GridItemTextField0 : {
      opacity   : 0,
      position  : "absolute",
      top       : 0,
      left      : 0,
      height    : 0,
      width     : 0,
      "z-index" : -1,
  },
});

export default RegisterLight1Style;
